module.exports = __webpack_public_path__ + "img/30.dc5275dc.jpg";